import { IRootState } from '@/store';
import { GetterTree } from 'vuex';
import { IEnvironmentState } from './state';

/** Liefert den Namen des Environments für die Vue-App. */
export const VUE_APP_ENVIRONMENT = 'VueAppEnvironment';

/** Liefert den App-Parameter 'CalendarCaseDefaultSurveyDateOffsetMonths'. */
export const APP_PARAMETER_CALENDAR_CASE_DEFAULT_SURVEY_DATE_OFFSET_MONTHS = 'AppParameterCalendarCaseDefaultSurveyDateOffsetMonths';

export const getters: GetterTree<IEnvironmentState, IRootState> = {
    [VUE_APP_ENVIRONMENT]: state => state.environment.vueAppEnvironment,
    [APP_PARAMETER_CALENDAR_CASE_DEFAULT_SURVEY_DATE_OFFSET_MONTHS]: state => state.environment.calendarCaseDefaultSurveyDateOffsetMonths
};
